import { render, staticRenderFns } from "./NpsmAddMain.vue?vue&type=template&id=7988d150&scoped=true&"
import script from "./NpsmAddMain.vue?vue&type=script&lang=js&"
export * from "./NpsmAddMain.vue?vue&type=script&lang=js&"
import style0 from "./NpsmAddMain.vue?vue&type=style&index=0&id=7988d150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988d150",
  null
  
)

export default component.exports